import { CheckOption } from '@/components/ui/custom/dataInput/CheckGroup';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useInfiniteService from '@/data/hook/useInfiniteService';
import useToggle from '@/data/hook/useToggle';
import { courseBasesQueryKeys } from '@/data/services/querykeys';
import { Course } from '@/models/Course';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import CourseCheckBoxFilter from './CourseCheckBoxFilter';
import { ListCoursePathFilters } from '@/data/services/coursePathServices';

type CourseFiltersProps = {
  courses?: number[];
  updateFilters(filter: ListCoursePathFilters): void;
};

export default function CourseFilters({
  courses = [],
  updateFilters,
}: CourseFiltersProps) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'coursesView.admin.filters',
  });
  const { isOpen, ...popupProps } = useToggle();
  const {
    results: courseBases,
    isInitialLoading: isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteService({
    ...courseBasesQueryKeys.list()._ctx.infinity,
    staleTime: REQUEST_STALE_TIME_IN_MS,
    enabled: isOpen,
  });
  function courseToOptions({ abbreviation: label, id }: Course): CheckOption {
    const checked = courses.includes(id);
    function onChange(e: ChangeEvent<HTMLInputElement>) {
      const isChecked = e.target.checked;
      let selectedCourse: number[] = [...courses];

      if (isChecked) {
        selectedCourse.push(id);
      } else {
        selectedCourse = selectedCourse.filter(courseId => courseId !== id);
      }
      updateFilters({ courseId: selectedCourse });
    }
    return {
      label,
      value: id,
      checked,
      onChange,
    };
  }
  const courseOptions = courseBases.map(courseToOptions);
  return (
    <CourseCheckBoxFilter
      {...popupProps}
      isOpen={isOpen}
      isLoading={isLoading}
      offset={[-5, 4]}
      placement="bottom-end"
      isFetchingNextPage={isFetchingNextPage}
      onReachEnd={fetchNextPage}
      hasNextPage={hasNextPage}
      options={courseOptions}
      text={t('courses')}
    />
  );
}
